import { Box, Title, TextDate } from "./Footer.styled";

export const TimeTable = () => {
  return (
      <Box>
        <Title>Графік роботи:</Title>
        <TextDate>Пн-Пт з 10:00 до 19:00
        </TextDate>
        <TextDate>Сб: вихідний
        </TextDate>
        <TextDate>Нд: вихідний
        </TextDate>
     </Box>
  );
};